import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { Router } from '@lit-labs/router';
import { store } from './store.js';
import '@healthgeek/ui';
import './layouts/site-chrome.js';
import './pages/home-page.js';
import './pages/content-pages.js';
import './pages/engage-pages.js';

@customElement('hg-app-shell')
export class HgAppShell extends LitElement {
  static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      min-height: 100dvh;
    }
    main {
      flex: 1;
    }
    @media (max-width: 899px) {
      main {
        padding-bottom: 0.5rem;
      }
    }
  `;

  private router = new Router(this, [
    { path: '/', render: () => html`<hg-home-page></hg-home-page>` },
    { path: '/story', render: () => html`<hg-mission-page></hg-mission-page>` },
    { path: '/mission', render: () => html`<hg-mission-page></hg-mission-page>` },
    { path: '/programs', render: () => html`<hg-programs-page></hg-programs-page>` },
    {
      path: '/programs/:slug',
      render: ({ slug }) => html`<hg-program-detail-page slug=${slug ?? ''}></hg-program-detail-page>`,
    },
    { path: '/learning', render: () => html`<hg-learning-page></hg-learning-page>` },
    { path: '/learning/courses', render: () => html`<hg-learning-page></hg-learning-page>` },
    { path: '/impact', render: () => html`<hg-impact-page></hg-impact-page>` },
    { path: '/where-we-work', render: () => html`<hg-where-page></hg-where-page>` },
    { path: '/governance', render: () => html`<hg-governance-page></hg-governance-page>` },
    { path: '/community', render: () => html`<hg-community-page></hg-community-page>` },
    { path: '/partners', render: () => html`<hg-partners-page></hg-partners-page>` },
    { path: '/news', render: () => html`<hg-news-page></hg-news-page>` },
    { path: '/get-involved', render: () => html`<hg-involved-page></hg-involved-page>` },
    { path: '/get-involved/donate', render: () => html`<hg-donate-page></hg-donate-page>` },
    { path: '/get-involved/volunteer', render: () => html`<hg-involved-page></hg-involved-page>` },
    { path: '/get-involved/partner', render: () => html`<hg-partners-page></hg-partners-page>` },
    { path: '/contact', render: () => html`<hg-contact-page></hg-contact-page>` },
    { path: '/transparency', render: () => html`<hg-transparency-page></hg-transparency-page>` },
    { path: '/legal/privacy', render: () => html`<hg-legal-page kind="privacy"></hg-legal-page>` },
    { path: '/legal/terms', render: () => html`<hg-legal-page kind="terms"></hg-legal-page>` },
    {
      path: '/legal/safeguarding',
      render: () => html`<hg-legal-page kind="safeguarding"></hg-legal-page>`,
    },
    { path: '/mou_robotsmali', render: () => html`<hg-mou-robotsmali-page></hg-mou-robotsmali-page>` },
    { path: '/*', render: () => html`<hg-not-found-page></hg-not-found-page>` },
  ]);

  connectedCallback() {
    super.connectedCallback();
    this.unsubscribe = store.subscribe(() => this.requestUpdate());
  }

  disconnectedCallback() {
    this.unsubscribe?.();
    super.disconnectedCallback();
  }

  private unsubscribe?: () => void;

  render() {
    return html`
      <hg-site-header></hg-site-header>
      <hg-nav-drawer></hg-nav-drawer>
      <main>${this.router.outlet()}</main>
      <hg-site-footer></hg-site-footer>
      <hg-bottom-nav></hg-bottom-nav>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'hg-app-shell': HgAppShell;
  }
}
